export interface RegistryModuleItem {
    modulePath: string;
    moduleName: string;
    componentName: string;
}

/**
 * A mapping of Component Name to Component Type
 * that must be updated with each new component
 * that you wish to load dynamically.
 */
export const DynamicContentOutletRegistry: RegistryModuleItem[] = [
    {
        componentName: 'TaskSectionComponent',
        moduleName: 'TaskContentModule',
        modulePath: 'src/app/dynamic-content/task-content.module'
    },
    {
        componentName: 'SelectExistingTaskComponent',
        moduleName: 'TaskContentModule',
        modulePath: 'src/app/dynamic-content/task-content.module'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractConsumerSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractPartySectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractProfileSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'LocationSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'LocationEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'SubLocationEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'PriorHistorySectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'LossHistoryEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'PriorHistoryEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractInterestSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractConditionDatesComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractSelectLOBComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'RatingOpenComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'SelectRatingObjectComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractSelectProductComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractChangePartyAffiliateComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractRejectWizardComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'SelectOpenProcedureComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'SelectScheduledProcedureComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'SelectLineWideProductComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractConditionSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractNameSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'TeamMemberSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractAttachmentSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractFormSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractFormEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'QuoteFormSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'BindFormSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractFactorSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'CDMAMiscArticleSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'CDMAERPSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'LineWideArticleSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'QuickReportSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'QuickReportSectionConfigPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractLineNavigatorComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractProcedureHistorySectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractCoverageCostSectionComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractCoverageCostLineWideEditPanelComponent'
    },
    {
        moduleName: 'ContractCommonContentModule',
        modulePath: 'src/app/dynamic-content/contract-common-content.module',
        componentName: 'ContractCoverageCostDetailEditPanelComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDAAVehicleSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDAAVehicleEditPanelComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDAADriverSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACAutoSymbolSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACStateRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACFilingSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACTruckEquipmentSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACTruckInterchangeSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDACTruckZoneSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDAPAllRiskSectionComponent'
    },
    {
        moduleName: 'ContractDetailAutoContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-auto-content.module',
        componentName: 'CDAPUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gl-content.module',
        componentName: 'CDGLClaimsMadeSectionComponent'
    },
    {
        moduleName: 'ContractDetailGLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gl-content.module',
        componentName: 'CDGLStateRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gl-content.module',
        componentName: 'CDGLClassRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gl-content.module',
        componentName: 'CDGLUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDPLRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDPLUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDPLIndividualsSectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDMMFacilitySectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDMMUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pl-content.module',
        componentName: 'CDMMIndividualSectionComponent'
    },
    {
        moduleName: 'ContractDetailAMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-am-content.module',
        componentName: 'CDAMAnimalSectionComponent'
    },
    {
        moduleName: 'ContractDetailDOContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-do-content.module',
        componentName: 'CDDORatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailEPContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ep-content.module',
        componentName: 'CDEPRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailCRContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-cr-content.module',
        componentName: 'CDCRRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailEOContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-eo-content.module',
        componentName: 'CDEORatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailHMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-hm-content.module',
        componentName: 'CDHMHomeownersSectionComponent'
    },
    {
        moduleName: 'ContractDetailHMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-hm-content.module',
        componentName: 'CDHMMobileHomeSectionComponent'
    },
    {
        moduleName: 'ContractDetailHMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-hm-content.module',
        componentName: 'CDHMCplSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMAccountsReceivableSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMBuildersRiskSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMBuildersRiskUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMCommunicationsSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMEDPSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMEDPUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMEquipmentFloaterSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMScheduleSummarySectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMSubcontractorUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMTransportationSectionComponent'
    },
    {
        moduleName: 'ContractDetailIMContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-im-content.module',
        componentName: 'CDIMTransportationRiggingSectionComponent'
    },
    {
        moduleName: 'ContractDetailEOContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-eo-content.module',
        componentName: 'CDEOJobSectionComponent'
    },
    {
        moduleName: 'ContractDetailEOContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-eo-content.module',
        componentName: 'CDEOUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGKContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gk-content.module',
        componentName: 'CDGKRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGDContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gd-content.module',
        componentName: 'CDGDPhysDamLocSectionComponent'
    },
    {
        moduleName: 'ContractDetailGKContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gk-content.module',
        componentName: 'CDGKUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailJBContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-jb-content.module',
        componentName: 'CDJBIndividualsSectionComponent'
    },
    {
        moduleName: 'ContractDetailJBContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-jb-content.module',
        componentName: 'CDJBRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailJBContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-jb-content.module',
        componentName: 'CDJBUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGDContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gd-content.module',
        componentName: 'CDGDRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailGDContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-gd-content.module',
        componentName: 'CDGDUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailUXContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ux-content.module',
        componentName: 'CDUXCareCustodyControlSectionComponent'
    },
    {
        moduleName: 'ContractDetailUXContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ux-content.module',
        componentName: 'CDUXLocationSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCBlanketRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCClassRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailUXContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ux-content.module',
        componentName: 'CDUXUnderlyingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCGlassScheduleSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCGlassUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pc-content.module',
        componentName: 'CDPCUnderwritingLocationSectionComponent'
    },
    {
        moduleName: 'ContractDetailPOContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-po-content.module',
        componentName: 'CDPORatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPXContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-px-content.module',
        componentName: 'CDPXRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailSBContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-sb-content.module',
        componentName: 'CDSBRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailLLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ll-content.module',
        componentName: 'CDLLRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailLLContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-ll-content.module',
        componentName: 'CDLLUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractDetailPPContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-pp-content.module',
        componentName: 'CDPPScheduleSectionComponent'
    },
    {
        moduleName: 'ContractDetailWCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-wc-content.module',
        componentName: 'CDWCClassRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailWCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-wc-content.module',
        componentName: 'CDWCIndividualSectionComponent'
    },
    {
        moduleName: 'ContractDetailWCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-wc-content.module',
        componentName: 'CDWCOtherStateSectionComponent'
    },
    {
        moduleName: 'ContractDetailWCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-wc-content.module',
        componentName: 'CDWCStateRatingSectionComponent'
    },
    {
        moduleName: 'ContractDetailWCContentModule',
        modulePath: 'src/app/dynamic-content/contract-detail-wc-content.module',
        componentName: 'CDWCUnderwritingSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractApplicationSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractApplicationRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractBindSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractBindRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractIssueSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractIssueRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractEndorseSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractEndorseRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractEndorseTemplateEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractScheduleCancelSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractScheduleCancelRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractCancelSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractCancelRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractCancelTemplateEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractReinstateSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractReinstateRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractSelfAuditSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractSelfAuditRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractSelfAuditTemplateEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractAuditSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractAuditRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractExtendTermSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractExtendTermRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractExtendTermTemplateEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRenewSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRenewRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRenewTemplateEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractReissueSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractReissueRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRewriteSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRewriteRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractDisableSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractChangeConsumerSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractChangeConsumerRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractNonRenewSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractNonRenewRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRateSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractRateRejectEditPanelComponent'
    },
    {
        moduleName: 'CorrespondContentModule',
        modulePath: 'src/app/dynamic-content/correspond-content.module',
        componentName: 'CorrespondMessageSectionComponent'
    },
    {
        moduleName: 'CorrespondContentModule',
        modulePath: 'src/app/dynamic-content/correspond-content.module',
        componentName: 'CorrespondAttachmentsSectionComponent'
    },
    {
        moduleName: 'CorrespondContentModule',
        modulePath: 'src/app/dynamic-content/correspond-content.module',
        componentName: 'CorrespondOptionsSectionComponent'
    },
    {
        moduleName: 'CorrespondContentModule',
        modulePath: 'src/app/dynamic-content/correspond-content.module',
        componentName: 'CorrespondRecipientDetailsComponent'
    },
    {
        moduleName: 'NoteContentModule',
        modulePath: 'src/app/dynamic-content/note-content.module',
        componentName: 'ContractNoteSectionComponent'
    },
    {
        moduleName: 'NoteContentModule',
        modulePath: 'src/app/dynamic-content/note-content.module',
        componentName: 'EntityNoteSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceItemSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceEntityLedgerSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceVoidMasterEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceVoidEntireSetDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InvoiceItemEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptEntityLedgerSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptTemplateReconObjectComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReceiptAdjustGLJAcctDistributeDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileItemEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileSelectItemsDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositItemSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositItemEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DepositSelectReceiptDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InstallmentSetSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InstallmentSetAdjustSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InstallmentSetSuspendEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InstallmentInvoiceAdjustItemEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'JournalEntrySectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'JournalEntryDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'JournalEntryGLJournalEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'JournalEntryVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BalanceForwardSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BalanceForwardDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BalanceForwardGLJournalEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BalanceForwardVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'InstallmentSetAllocateDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DisbursementSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DisbursementVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DisbursementGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DisbursementEntityLedgerSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'DisbursementDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BankReconciliationDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'BankReconciliationSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'PeriodEndSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'PeriodEndGLJournalSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'PeriodEndDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'PeriodEndPreCloseDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'VendorBillSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'VendorBillGLJournalEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'VendorBillVoidEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'VendorBillEntityLedgerSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ThirteenthPeriodSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ThirteenthPeriodGljEntryEditPanelComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ThirteenthPeriodDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'LockboxImportDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'CheckFoulSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'CheckFoulDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'CheckPrintDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'CheckReprintDialogComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'CheckPrintSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'LockboxSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'PostingWizardSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileAutoBuildSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileAutoBuildDocumentSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificatePropSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateIMSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateCrimeSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateOtherSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateBoilMachSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateHoldersSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'PropertyCertificateDocumentSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'EntityConsumerPropertyCertificateSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'EntityConsumerPropertyCertificateHoldersSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'EntityConsumerLiabilityCertificateSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'EntityConsumerLiabilityCertificateHoldersSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateGLSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateAutoSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateGarageSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateExcessSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateWorkersCompSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateOtherSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateHoldersSectionComponent'
    },
    {
        moduleName: 'CertificateContentModule',
        modulePath: 'src/app/dynamic-content/certificate-content.module',
        componentName: 'LiabilityCertificateDocumentSectionComponent'
    },
    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'ReconcileItemDialogComponent'
    },

    {
        moduleName: 'AccountingProcedureContentModule',
        modulePath: 'src/app/dynamic-content/accounting-procedure-content.module',
        componentName: 'OffsetDeferredSectionComponent'
    },

    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteSetCorrespondCoverSectionComponent'
    },
    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteSetSummarySectionComponent'
    },
    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteSetAttachmentSectionComponent'
    },
    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteDetailSectionComponent'
    },
    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteOptionNavigatorComponent'
    },
    {
        moduleName: 'QuoteSetContentModule',
        modulePath: 'src/app/dynamic-content/quote-set-content.module',
        componentName: 'QuoteSetSelectImportOptionsDialogComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'MarketSetBaseCorrespondCoverSectionComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'MarketSetBaseLetterSectionComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'MarketSetAttachmentSectionComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'MarketOptionSectionComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'MarketOptionNavigatorComponent'
    },
    {
        moduleName: 'MarketSetContentModule',
        modulePath: 'src/app/dynamic-content/market-set-content.module',
        componentName: 'SelectMarketComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractQuoteSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractQuoteRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractMarketSectionComponent'
    },
    {
        moduleName: 'ContractProcedureContentModule',
        modulePath: 'src/app/dynamic-content/contract-procedure-content.module',
        componentName: 'ContractMarketRejectEditPanelComponent'
    },
    {
        moduleName: 'ContractAssemblerContentModule',
        modulePath: 'src/app/dynamic-content/contract-assembler-content.module',
        componentName: 'ContractAssemblerDocumentPackageSectionComponent'
    },
    {
        moduleName: 'ContractConditionManagerContentModule',
        modulePath: 'src/app/dynamic-content/contract-condition-manager-content.module',
        componentName: 'ContractConditionManagerSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderContractProcedureSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderInvoiceSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderReceiptSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderBalanceForwardSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderInstallmentSetSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderReconcileSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderDepositSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderJournalEntrySectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderDisbursementSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderBankReconciliationSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderCorrespondSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderContractItemsSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderPeriodEndSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderVendorBillSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderThirteenthPeriodSectionComponent'
    },
    {
        moduleName: 'FinderContentModule',
        modulePath: 'src/app/dynamic-content/finder-content.module',
        componentName: 'FinderLockboxSectionComponent'
    },
    {
        moduleName: 'FormControlModule',
        modulePath: 'src/app/controls/form-controls/form-control.module',
        componentName: 'EditStatusComponent'
    },
    {
        moduleName: 'FormControlModule',
        modulePath: 'src/app/controls/form-controls/form-control.module',
        componentName: 'EditSanctionStatusComponent'
    },
    {
        moduleName: 'SearchContentModule',
        modulePath: 'src/app/dynamic-content/search-content.module',
        componentName: 'AdvancedSearchDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/search-content.module',
        componentName: 'DateFormulaDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UxDesignerPageSectionDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UxDesignerPageSectionConfigPanelComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UserDefinedSectionComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UserDefinedSectionConfigPanelComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UxDesignerCollectionConfigDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UxDesignerLayoutConfigDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'UserDefinedValidationDialogComponent'
    },
    {
        moduleName: 'CommonContentModule',
        modulePath: 'src/app/dynamic-content/common-content.module',
        componentName: 'InterfaceDialogComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityDetailSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityLicenseSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityBrokerRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityBrokerEOSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityBrokerAgreementSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityBrokerAgreementTermSubSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityBrokerAgreementTermEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityConsumerRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntitySupplierRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntitySupplierAdmittedSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntitySupplierAgreementSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntitySupplierAgreementTermEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityThirdPartyRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityEmployeeRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityProviderRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityGLAllocationsSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityTaxAuthorityRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityFinanceCompanyRoleSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityAddressSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityPhoneSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityAffiliateSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityAddressEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityPhoneEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityAffiliateEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityCommentEditPanelComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'UserOptionSectionComponent'
    },
    {
        moduleName: 'EntityContentModule',
        modulePath: 'src/app/dynamic-content/entity-content.module',
        componentName: 'EntityCommentSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'WebhookSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'ActionSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'ActivityLogsSectionComponent'
    },

    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'UserDefinedProceduresSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'UserDefinedProcedureSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'IntegrationServiceSectionComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'IntegrationServiceActionEditPanelComponent'
    },
    {
        moduleName: 'ConfigurationContentModule',
        modulePath: 'src/app/dynamic-content/configuration-content.module',
        componentName: 'IntegrationServiceSigningKeyDialogComponent'
    },
    {
        componentName: 'TestPageSectionComponent',
        moduleName: 'TestPageContentModule',
        modulePath: 'src/app/dynamic-content/test-page-content.module'
    },
    {
        componentName: 'TestPageSection2Component',
        moduleName: 'TestPageContentModule',
        modulePath: 'src/app/dynamic-content/test-page-content.module'
    }
];
